export default {
  data() {
    return {
      success: true,
      message: null,
    }
  },
  async created() {
    const loader = this.$loading.show();

    try {
      const response = await this.axios.post(`activate/${this.$route.params.email}/${this.$route.params.activationToken}`);

      if (response && response.data) {
        this.success = response.data.success;
        this.message = response.data.message || response.data.data;
      }

      loader.hide();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
      loader.hide();
    }
  }
};
